import { mapGetters } from 'vuex'
import { AUTH_USER, IS_AUTHENTICATED } from '@/utils/store/getterTypes'

export default {
  computed: {
    ...mapGetters('auth', {
      user: AUTH_USER,
      isAuthenticated: IS_AUTHENTICATED
    })
  },
  methods: {
    logout () {
      return this.$auth.logout()
    }
  }
}
